import React, { Component } from 'react'
import styled from 'styled-components'

export class TrainingCategoryContent extends Component {
  state = {
    isOpen: false
  }

  toggleOpen = () => {
    this.setState(prevState => {
      return { isOpen: !prevState.isOpen }
    })
  }

  render() {
    const { section_title, content, onClick } = this.props
    const { isOpen } = this.state
    return (
      <TrainingThemeContentTopic onClick={this.toggleOpen}>
        <TrainingThemeTopicMain>
          <div>
            <span>•</span>
            <span>{section_title}</span>
          </div>
          <i className={`fa fa-chevron-${isOpen ? 'up' : 'down'}`}/>
        </TrainingThemeTopicMain>
        {isOpen && (
        <TrainingThemeTopicQuestions>
          { content.map(item =>  (<span key={item.topic} onClick={() => onClick(item.topic)}>{item.topic}</span>))}
        </TrainingThemeTopicQuestions>
        )}
      </TrainingThemeContentTopic>
    )
  }
}

const TrainingThemeContentTopic = styled.div`
font-family: 'Circular';
font-weight: 700;
color: #4a4a4a;
font-size: 20;
display: flex;
flex-direction: column;
padding: 25px 0;
border-bottom: 1px solid #F1F1F4;
`

const TrainingThemeTopicMain = styled.div`
display: flex;
flex-direction: row;
justify-content: space-between;
cursor: pointer;
align-items: center;

div:first-child {
  display: flex;
  padding-right: 15px;

  span:first-child {
    padding-right: 25px;
  }
}

i {
  color: #0588dd;
  font-size: 14;
}
`

const TrainingThemeTopicQuestions = styled.div`
display: flex;
flex-direction: column;
padding-left: 35px;

span {
  font-family: 'Circular';
  font-weight: 500;
  cursor: pointer;
  font-weight: normal;
  padding-top: 45px;
  padding-right: 35px;
}
`
